module.exports = __webpack_public_path__ + "static/media/LeftImg.3880c980.png";